import React, { createContext, useContext, useEffect, useState, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { FiAlertCircle } from "react-icons/fi";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "./Modal";
import Button from "./Button";
import { cancelConfirmations, getConfirmation, resolveConfirmation, subscribeConfirmations } from "./confirmAction";
import "./Feedback.css";

const FeedbackContext = createContext(false);
function ConfirmationHost() {
  const request = useSyncExternalStore(subscribeConfirmations, getConfirmation, () => null);
  useEffect(() => () => cancelConfirmations(), []);
  if (!request) return null;
  return <Modal role="alertdialog" size="small" title={request.title} onClose={() => resolveConfirmation(false)}
    footer={<><Button data-autofocus="true" onClick={() => resolveConfirmation(false)}>Cancel</Button><Button variant={request.danger ? "danger" : "primary"} onClick={() => resolveConfirmation(true)}>{request.confirmLabel || "Continue"}</Button></>}>
    <div className="navo-confirm__icon" aria-hidden="true"><FiAlertCircle /></div><p className="navo-confirm__description">{request.description}</p>
  </Modal>;
}
function ToastHost() {
  const [host] = useState(() => document.createElement("div"));
  useEffect(() => {
    host.className = "navo-toast-host";
    const move = () => {
      const dialogs = document.querySelectorAll('dialog[open]');
      const parent = dialogs[dialogs.length - 1] || document.body;
      if (host.parentElement !== parent) parent.appendChild(host);
    };
    move();
    const observer = new MutationObserver(move);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] });
    return () => { observer.disconnect(); host.remove(); };
  }, [host]);
  return createPortal(<ToastContainer position="top-right" autoClose={4500} hideProgressBar newestOnTop closeOnClick pauseOnHover limit={3} />, host);
}
export default function FeedbackProvider({ children }: { children: React.ReactNode }) {
  const exists = useContext(FeedbackContext);
  if (exists) return <>{children}</>;
  return <FeedbackContext.Provider value><>{children}<ConfirmationHost /><ToastHost /></></FeedbackContext.Provider>;
}
